import { useTheme } from '../../../hooks/useTheme';
import { TextFieldStyles, TextFieldProps } from './TextField.types';

const useStyles = (
  props: Pick<
    TextFieldProps,
    | 'colorText'
    | 'label'
    | 'noLabel'
    | 'error'
    | 'isLabelOnLeft'
    | 'onArrowUp'
    | 'onArrowDown'
    | 'showErrorWhenDisabled'
  >,
  isInputDisabled: boolean | undefined,
): TextFieldStyles => {
  const theme = useTheme();

  // @ts-expect-error
  const colorText = theme.palette.text[props.colorText ?? ''] ?? props.colorText;
  const errorColor = theme.palette.error.main;

  const styles: TextFieldStyles = {
    labelInputContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.tertiary,
      width: '100%',
    },
    requiredAsterisk: {
      color: errorColor,
      marginLeft: '0.05rem',
    },
    characterCounter: {
      float: 'right',
      color: colorText,
      marginLeft: 'auto',
    },
    labelContainer: {
      display: 'flex',
      color: colorText,
      paddingTop: props.noLabel ? 'calc(0.2rem + 12px)' : undefined,
    },
    inputContainer: {
      alignItems: 'center',
      marginTop: props.label && !props.isLabelOnLeft ? '0.2rem' : undefined,
      position: 'relative',
      display: 'flex',
      gap: theme.spacing.tertiary,
      borderRadius: theme.borderRadius.sm,
      border:
        (!isInputDisabled || props.showErrorWhenDisabled) && props.error
          ? `1px solid ${errorColor}`
          : 0,
      boxShadow: theme.boxShadows.secondary.inset,
      backgroundColor: isInputDisabled
        ? theme.palette.background.secondary
        : theme.palette.text.secondary,
      ':hover': {
        boxShadow: !isInputDisabled ? theme.boxShadows.secondary.inset : undefined,
      },
      ':focus-within': {
        boxShadow: !isInputDisabled ? theme.boxShadows.secondary.inset : undefined,
      },
      padding: `0 ${theme.spacing.secondary}`,
      transition: `all ${theme.transitions.primary}`,
      ...(props.isLabelOnLeft ? { width: '100%' } : {}),
    },
    input: {
      display: 'block',
      width: '100%',
      outline: 'none',
      border: 0,
      background: 'none',
      fontSize: theme.fontSizes.h5,
      color: colorText,
      minHeight: '34px',
      minWidth: '0.5rem',

      '::placeholder': {
        color: theme.palette.text.primary,
        opacity: '0.3',
      },
    },
    arrowContainer: {
      display: props.onArrowUp || props.onArrowDown ? 'flex' : 'none',
      flexDirection: 'column',
      justifyContent: 'center',
      marginTop: '0.1rem',
      gap: '0.15rem',
    },
    arrowItem: {
      height: 8,
      width: 12,
      marginBottom: 2,
      userSelect: 'none',
      paddingLeft: 2,
    },
    mainContainer: {},
  };

  return styles;
};

export default useStyles;
